<template>
  <vs-button
      :id="getFieldID(schema)"
      @click="onClick"
      :name="schema.inputName"
      :disabled="disabled"
      :class="classes"
      :color="schema.buttonColor || 'light'"
      :type="schema.buttonType || 'filled'"
      v-attributes="'input'">
    <vue-element-loading :active="schema.loading === true"></vue-element-loading>
    {{ schema.buttonText }}
  </vs-button>
</template>

<script>
import abstractField from 'vue-form-generator/src/fields/abstractField';

export default {
  mixins: [abstractField],
  computed: {
    classes() {
      return ['text-white small', this.schema.fieldClasses];
    }
  },
  methods: {
    onClick($event) {
      if (this.schema.onClick) {
        this.schema.onClick(this.model, this.schema, $event);
      }
    }
  }
};
</script>

<style lang="scss">
</style>
